module.exports = __webpack_public_path__ + "assets/retina_TEquilateralDetailed.a9e9f8a95be93cd9bab3f95e371506ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_TEquilateralDetailed.png
// module id = 732
// module chunks = 0